module.exports = __webpack_public_path__ + "img/50.2.TN.ee8e3331.png";